const POSTHOG = {
    API_HOST: 'https://eu.posthog.com/',
    API_KEYS: {
        PRODUCTION: 'phc_g7L4YzbTfaZMVLuXN3xOI2z51oBAeh8lHHRzk1tsgk1',
        STAGING: 'phc_tvxObc3QJVPIosTnblMpJPL84YsrIHfBGtHStZXqExK'
    }
};

export default POSTHOG;
